// extracted by mini-css-extract-plugin
export default {"socialIcons":"NavIcons_socialIcons__mONec","socialIcon":"NavIcons_socialIcon__gpoZN"};